import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';

export const WeaponDrill: WeaponDefinition = {
  id: 'drill',
  name: 'Pneumatic Drill',
  icon: 'drill.1.png',
  category: 'utility',
  maxAmmo: 5,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: false,

  fire(_ctx: WeaponContext): WeaponResult {
    return {
      success: true,
      entities: [],
      message: 'Drill activated',
      bonusWeapon: 'drill_active',
    };
  },
};
